<template>
  <div :class="ui.bkgdColor">
      <v-layout class="text-xs-right mt-2 mr-2">
        <v-spacer/>
        <v-btn :color="ui.btnColor"
        :disabled="getResultsList.length > 30 || this.disableNew"
        flat @click="openDialog()">
          <v-icon left :color="ui.btnColor"> add </v-icon>
          Result
        </v-btn>
      <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
        <v-card :color="ui.bkgdColor" :text-color="ui.bkgdColor">
          <v-card-title class="title wplblue0--text">
            New Technical Result
          </v-card-title>
          <v-progress-linear color="blue-grey" height="1" value="100">
          </v-progress-linear>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm8>
                  <v-text-field
                  v-model="localForm.title"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="title"
                  label="technical result"
                  required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                  v-model="localForm.type"
                  :items="resultsTypeOptions"
                  :rules="ruleMustBeSelected"
                  prepend-icon="grid_view"
                  label="type"
                  required
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="localForm.id"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="fingerprint"
                  label="result id"
                  required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                  v-model="localForm.dis"
                  :items="engineeringDiscipline"
                  prepend-icon="engineering"
                  label="discipline"
                  required
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                  v-model="localForm.own"
                  :items="resultsOwnerOptions"
                  prepend-icon="person"
                  label="own"
                  required
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm6>
                  <v-select
                  v-model="localForm.cat"
                  :items="resultsCategoryOptions"
                  prepend-icon="settings"
                  label="category"
                  required
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="localForm.ref"
                  :rules="mustBeLessThanSmallNotRequired"
                  prepend-icon="radio_button_unchecked"
                  label="reference"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row :class="ui.textSubheading">
                <div class="ml-4 mt-4 mb-2">
                  Inspection and Test Criteria
                </div>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="localForm.method"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="adjust"
                  label="method"
                  required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="localForm.spec"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="science"
                  label="specification"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm4>
                  <v-select
                  v-model="localForm.cond"
                  :items="conditionForActivityOptions"
                  prepend-icon="build_circle"
                  label="condition"
                  required
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                  v-model="localForm.test"
                  :items="resultTestOptions"
                  prepend-icon="bubble_chart"
                  label="outcome"
                  required
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="localForm.unit"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="straighten"
                  label="unit"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <div v-if="localForm.test === 'Number'">
                <v-layout row wrap class="mr-2">
                  <v-flex xs12 sm4 offset-sm4>
                    <v-text-field
                    v-model="localForm.rhi1"
                    :rules="mustBeNumberNegOrPos"
                    prepend-icon="warning"
                    label="high warning"
                    required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-text-field
                    v-model="localForm.rhi2"
                    :rules="mustBeNumberNegOrPos"
                    prepend-icon="error"
                    label="high fault"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mr-2">
                  <v-flex xs12 sm4 offset-sm4>
                    <v-text-field
                    v-model="localForm.rlo1"
                    prepend-icon="warning"
                    :rules="mustBeNumberNegOrPos"
                    label="low warning"
                    required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-text-field
                    v-model="localForm.rlo2"
                    :rules="mustBeNumberNegOrPos"
                    prepend-icon="error"
                    label="low fault"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </div>
              <div v-else>
                <v-layout row wrap class="mr-2">
                  <v-flex xs12 sm4 offset-sm4>
                    <v-text-field
                    v-model="localForm.rin1"
                    :rules="ruleMustBeFilledANDLessThan50"
                    prepend-icon="warning"
                    label="warning criteria"
                    required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-text-field
                    v-model="localForm.rin2"
                    :rules="ruleMustBeFilledANDLessThan50"
                    prepend-icon="error"
                    label="fault criteria"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </div>
              <v-layout row :class="ui.textSubheading">
                <div class="ml-4 mt-4 mb-2">
                  Technical Results Comments
                </div>
              </v-layout>
              <v-layout row class="ml-2 mr-2">
                <v-flex xs12>
                  <v-textarea
                  v-model="localForm.com"
                  :disabled="false"
                  :outline="true"
                  required
                  :rules="ruleMustBeNotUndefinedANDLessThan1000"
                  label="technical results requirements"
                  auto-grow
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <v-layout row>
            <v-btn @click="closeDialog()" color="wplblue0" flat>
              <v-icon left> exit_to_app </v-icon>
              Close
            </v-btn>
            <v-spacer/>
            <v-btn @click="validate" color="wplblue0" flat
            >
              <v-icon left> add </v-icon>
              add
            </v-btn>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import rulesTextfield from "@/data/rules/mixins/rulesTextfield.js";
import master from "@/data/forms/mixins/master.js";
import listFunctions from "@/data/functions/mixins/listFunctions.js";
import linkFunctions from "@/data/functions/mixins/linkFunctions.js";
import generateForms from "@/data/functions/mixins/generateForms.js";
import techOptions from "@/data/options/mixins/techOptions.js";
import resultsOptions from "@/data/options/mixins/resultsOptions.js";
import executionOptions from "@/data/options/mixins/executionOptions.js";
import uisettings from "@/frame/theme/mixins/uisettings.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";
import moment from "moment";

export default {
  // eslint-disable-next-line
  mixins: [
    techOptions,
    listFunctions,
    linkFunctions,
    generateForms,
    master,
    resultsOptions,
    rulesTextfield,
    uisettings,
    generateID,
    docRevsModFunctions,
    executionOptions
  ],
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getResultsList",
      "getResultsListCounter",
      "getDetail",
      "getDetailChar",
      "getUser"
    ]),
    ui() {
      return this.uiTheme1;
    },
    disableNew() {
      let logic = null;
      if (
        this.getDetailBasic.tag === "E8" ||
        this.getDetailBasic.tag === "W1" ||
        this.getDetailBasic.tag === "W2" ||
        this.getDetailBasic.tag === "M5"
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    }
  },
  data() {
    return {
      dialog: false,
      valid: false,
      localForm: {
        id: "R1", // parts Id
        title: "Result 1", // parts title
        type: "Test", // typ
        cat: "General",
        dis: "Electrical", // discipline
        com: "", // comment
        own: "M", // who is doing it
        method: "M1", // method
        ref: "", // standard
        cond: "Online", // condition
        spec: "S1",
        pass: "OK",
        test: "P/F",
        result: "",
        unit: "-",
        rin1: "K1",
        rin2: "F1",
        rhi1: "10",
        rhi2: "100",
        rlo1: "1",
        rlo2: "0"
      }
    };
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    openDialog() {
      this.dialog = true;
      // this.$store.dispatch("changeResultsList", []);
      // this.$refs.form.reset();
    },
    refreshList() {
      let store = "changeResultsListCounter";
      // counter +1 and -1, needed to refresh the list
      this.$store.dispatch(store, this.getResultsListCounter + 1);
      this.$store.dispatch(store, this.getResultsListCounter - 1);
      this.$store.dispatch("changeDataSavePendingIndication", true);
      this.saveDocumentRevMod(5.12, 1); // engResults removed.
    },
    validate() {
      // cosole.log(this.taskForm)
      // this.$refs.form.validate() === true
      if (this.$refs.form.validate() === true) {
        // NEW PART
        let tempForm = this.generateResultsForm();
        let tempList = this.getResultsList;

        // BASIC
        tempForm.basic.idg = this.generateIDG("date-gid");
        tempForm.basic.did = this.generateDID("DATE", "E5");
        tempForm.basic.idi = this.generateIDI(tempList);
        tempForm.basic.title = this.localForm.title;
        tempForm.basic.id = this.localForm.id;
        tempForm.basic.tag = "E5";

        // CHAR
        tempForm.char.type = this.localForm.type;
        tempForm.char.dis = this.localForm.dis;
        tempForm.char.method = this.localForm.method;
        tempForm.char.cond = this.localForm.cond;
        tempForm.char.cat = this.localForm.cat;
        tempForm.char.com = this.localForm.com;
        tempForm.char.ref = this.localForm.ref;
        tempForm.char.spec = this.localForm.spec;
        tempForm.char.pass = this.localForm.pass;
        tempForm.char.own = this.localForm.own;
        tempForm.char.status = "C";
        tempForm.char.test = this.localForm.test;
        tempForm.char.unit = this.localForm.unit;
        tempForm.char.rhi1 = this.localForm.rhi1;
        tempForm.char.rhi2 = this.localForm.rhi2;
        tempForm.char.rlo1 = this.localForm.rlo1;
        tempForm.char.rlo2 = this.localForm.rlo2;
        tempForm.char.rin1 = this.localForm.rin1;
        tempForm.char.rin2 = this.localForm.rin2;

        // STATS
        tempForm.stats.dcrt = moment().format();
        tempForm.stats.uname = this.getUser.basic.title;
        tempForm.stats.uemail = this.getUser.basic.email;
        tempForm.stats.udid = this.getUser.basic.did;

        // LIST UPDATE
        var obj = Object.assign({}, tempForm);
        var parseobj = JSON.parse(JSON.stringify(obj));
        var newList = this.appendItemLimited(parseobj, tempList, 10);

        // STORE UPDATE
        this.$store.dispatch("changeResultsList", newList);
        this.$store.dispatch("changeResultsListCounter", tempForm.basic.idi);
        this.refreshList();

        // RESET DETAIL LINK
        this.resetLinkAppendedProgram();

        // Close Window
        this.dialog = false;
      }
    }
  }
};
</script>
